module.exports = __webpack_public_path__ + "img/flat-foot-shoe.ccf863f8.svg";